import { render, staticRenderFns } from "./AppIconUpload.vue?vue&type=template&id=24a276b1"
import script from "./AppIconUpload.vue?vue&type=script&lang=js"
export * from "./AppIconUpload.vue?vue&type=script&lang=js"
import style0 from "./AppIconUpload.vue?vue&type=style&index=0&id=24a276b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports